var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner-border text-primary pos",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Загрузка...")])])}]

export { render, staticRenderFns }